module.exports = __webpack_public_path__ + "static/design-pattern.6e38aa52.svg";